import { defineStore } from "pinia";
import GlobalUtil from "../../utils/pricetravel/shared/globalUtil";
import { SearchHistory } from "../../utils/pricetravel/shared/searchHistory";
import BookerTracker from "../../MetricsTracker/booker/metrics";

const fn = window.__pt.fn;
const config = window.__pt.settings.site;
const setting = window.__pt.settings;
const lang = window.__pt.ln;

const _globalUtil = new GlobalUtil();
const _userKey = _globalUtil.getUserKey();
const _tracker = new BookerTracker();
const defaultDate = fn.getDate();

const __ = (str, values = []) => {
  const _ = window._;
  let formatted = _.get(window.i18n, str, str);

  if (values.length) {
    formatted = _.replace(formatted, /\{\d\}/g, (match) => {
      const index = match.replace(/\{|\}/g, "");
      return values[index] || match;
    });
  }

  return formatted;
};

export const usePackageBookerStore = defineStore("packageBooker", {
  state: () => ({
    form: {
      from: "",
      to: "",
      dates: "",
      guests: "",
    },
    fieldErrors: {
      to: "",
      from: "",
      dates: "",
      guests: "",
    },
    book: setting.defaultPackage,
    recentSearches: {
      from: [],
      to: [],
    },
    popularDestinations: {
      from: [],
      to: [],
    },
    searchResults: {
      from: [],
      to: [],
    },
    algoliaUrl: "https://img.cdnpth.com/media/assets/recent-search-imgs/iatas/",
    OpenSearch: {
      from: false,
      to: false,
    },
    CloseSearch: {
      from: false,
      to: false,
    },
    lastQuery: "",
    localeDatePicker: {
      format: setting.formatBoxDate,
      firstDay: 0,
      applyLabel: lang.ok,
      cancelLabel: lang.cancel,
    },
    settingPaxes: {
      minAdults: 1,
      maxAdults: 9,
      minChildren: 0,
      maxChildren: 6,
      minAge: 1,
      maxAge: 17,
      rooms: 4,
      totalPaxes: 9,
    },
  }),
  getters: {
    isFormValid(state) {
      return (
        state.form.from &&
        state.form.from.trim() !== "" &&
        state.form.to &&
        state.form.to.trim() !== "" &&
        state.form.dates &&
        state.form.dates.trim() !== "" &&
        state.form.guests &&
        state.form.guests.trim() !== ""
      );
    },
    totalAdults(state) {
      if (_globalUtil.getIsArray(state.book.paxes)) {
        return state.book.paxes.reduce((sum, room) => sum + (room.adults || 0), 0);
      }
      return state.book.paxes.adults || 1;
    },
    totalChildren(state) {
      if (_globalUtil.getIsArray(state.book.paxes)) {
        return state.book.paxes.reduce((sum, room) => sum + (room.children ? room.children.length : 0), 0);
      }
      return state.book.paxes.children ? state.book.paxes.children.length : 0;
    },
    paxSummary(state) {
      const adults = state.totalAdults;
      const children = state.totalChildren;
      const rooms = _globalUtil.getIsArray(state.book.paxes) ? state.book.paxes.length : (state.book.rooms || 1);

      const roomTitle = rooms === 1 ? lang.room : lang.rooms;
      const adultsTitle = adults === 1 ? lang.adult : lang.adults;
      const childrenTitle = children === 1 ? lang.child : lang.children;

      let childrenText = children > 0 ? ` ${children} ${childrenTitle}, ` : "";
      return `${adults} ${adultsTitle},${childrenText} ${rooms} ${roomTitle}`;
    },
  },
  actions: {
    validateForm(omitField = false) {
      this.clearFieldErrors();
      let valid = true;

      if (!this.book.place_name || !this.form.from || this.form.from.trim() === "") {
        if (!omitField) {
          this.setFieldError("from", __("booker.select_origin"));
        }
        valid = false;
      }
      if (!this.form.to || this.form.to.trim() === "") {
        if (!omitField) {
          this.setFieldError("to", __("booker.select_destination"));
        }
        valid = false;
      }
      if (!this.form.dates || this.form.dates.trim() === "") {
        if (!omitField) {
          this.setFieldError("dates", __("booker.select_dates"));
        }
        valid = false;
      }
      if (!this.form.guests || this.form.guests.trim() === "") {
        if (!omitField) {
          this.setFieldError("guests", __("booker.select_guests"));
        }
        valid = false;
      }
      if (this.form.to && this.form.from &&
        this.book.place_selected.placeCode == this.book.place_selected_to.placeCode
      ) {
        if (!omitField) {
          this.setFieldError("to", __("booker.select_different_destination"));
        }
        valid = false;
      }
      if(this.validAgeChildrenforAdult()){
        if (!omitField) {
          this.setFieldError("guests", __("booker.notificationKids") );
        }
        valid = false;
      }
      return valid;
    },
     validAgeChildrenforAdult() {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let agekids = [];
        let rooms = this.book.paxes.length;

        for (let i = 0; i < rooms; i++) {
            const room = this.book.paxes[i];

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");

        let totalChildren = 0;
        if (paxesKeys[`adults`] < paxesKeys[`kids`]) {

            agekids.forEach((age, index) => {
                if (age == 1)
                    totalChildren++;
            });

            if (totalChildren > paxesKeys[`adults`]) {
                return true;
            }
            else return false;
        }
        else return false;

    },
    getAnalyticsTags() {
      var arrTags = [];
      if (fn.mobileAndTabletCheck()) {
        arrTags.push("web_mobile");
      } else {
        arrTags.push("web_desktop");
      }
      var pathName = _globalUtil.getFirstPathSegment();
      if (pathName == "hotel") {
        arrTags.push("detail");
      } else if (pathName == "hoteles" || pathName == "hotels") {
        arrTags.push("list");
      } else if (setting.page == "landings") {
        arrTags.push("landings");
      } else {
        arrTags.push("home");
      }
      return arrTags.join(",");
    },
    async fetchSearchResults(value, mobile, list) {
      if (!value || (value && value.length < 3)) {
        this.searchResults[list] = [];
        if (!mobile) {
          this.OpenSearch[list] = false;
        }
        return;
      }
      let destination = list === "from" ? 0 : 1;
      const version = list === "from" ? "v2" : "v1";
      const params = {
        query: value,
        language: config.culture,
        placeTypes: config.placesTypePackages,
        from: 0,
        size: 10,
        usersearch: _userKey,
        site: config.code,
        destination: destination,
        version: version,
        analyticsTags: this.getAnalyticsTags(),
      };

      let response = await axios
        .get(config.endPoints.suggestionPackageUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = response.data || [];
        if (data.length > 0) {
          this.lastQuery = params.query;
          _tracker.metricAutocompletePackageShown(
            params.query,
            response.data,
            list,
          );
        } else {
          _tracker.metricAutocompletePackageNoResults(params.query);
        }
        this.searchResults[list] = data;
        if (!mobile) {
          this.OpenSearch[list] = false;
          setTimeout(() => {
            this.OpenSearch[list] = true;
          }, 10);
        }
      }
    },
    async fetchPopularDestinations(element, origin) {
      if (this.popularDestinations[element].length > 0) {
        return;
      }
      const params = {
        analyticsTags: this.getAnalyticsTags(),
        from: 0,
        language: config.language,
        placeTypes: 0,
        site: config.code,
        size: 5,
        usersearch: _userKey,
        recommendation: true,
        origin: element == "to" ? origin : null,
      };
      let response = await axios
        .get(config.endPoints.suggestionPackageUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = response.data || [];
        this.popularDestinations[element] = data;
      }
    },
    loadSearchHistory() {
      const history = SearchHistory.getPackage("P");
      this.recentSearches = history;
      ["from", "to"].forEach((key) => {
        this.recentSearches[key]?.forEach((item) => {
          item.displayDestinationHtml = this.stripHtml(
            item.displayDestinationHtml,
          );
          item.code = this.stripHtml(item.code);
          item.placeName = this.stripHtml(item.placeName);
        });
      });
    },
    stripHtml(html) {
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    updateInputPaxes() {
      const summary = this.paxSummary;
      this.book.paxes_name = summary;
      this.book.paxes_people = this.totalAdults + this.totalChildren;
      this.book.capacityTotal = this.book.paxes_people;
      this.form.guests = summary;
    },
    getInitialDate(date = fn.getDate(), value = config.bookerDefaultCheckInDay) {
      let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
      dateNew.setDate(dateNew.getDate() + value);
      return dateNew;
    },
    initialDefaultDate() {
      this.book.checkIn = this.getInitialDate(defaultDate);
      this.book.checkOut = this.getInitialDate(
        defaultDate,
        config.bookerDefaultCheckInDay + config.bookerDefaultCheckOutDay,
      );
    },
    getUserSelectionParams() {
      let params = fn.search();
      let data = {};
      let _placeOrigin = window.__pt.placeOrigin || {};
      let _placeDestination = window.__pt.placeDestination || {};

      data.place_name = _placeOrigin.placeDescription || "";
      data.place_name_to = _placeDestination.placeDescription || "";

      data.place_selected = _placeOrigin;
      data.place_selected_to = _placeDestination;

      data.checkIn = params.startingFromDateTime || this.book.checkIn;
      data.checkOut = params.returningFromDateTime || this.book.checkOut;

      let rooms = +params.rooms || 0;
      let paxes = [];

      for (let i = 0; i < rooms; i++) {
        let index = i + 1;
        let pax = {
          adults: +(params[`room${index}.adults`] || 2),
          children: [],
        };
        let children = params[`room${index}.agekids`];
        if (children) {
          let childrenSplit = children.split(",");
          for (var c = 0; c < childrenSplit.length; c++) {
            pax.children.push({
              year: +childrenSplit[c] || 0,
            });
          }
        }
        paxes.push(pax);
      }

      if (paxes && !paxes.length) {
        paxes = this.book.paxes;
      }

      data.paxes = paxes;
      return data;
    },
    initSearchBox() {
      let paramsData, storageData;
      if (setting.page != "home") {
        paramsData = this.getUserSelectionParams();
      } else {
        storageData = SearchHistory.getFirstEntry("P");
      }

      if (storageData) {
        storageData.place_name = null;
        storageData.place_name_to = null;
        storageData.place_selected = {};
        storageData.place_selected_to = {};
      }

      this.book = paramsData || storageData || this.book;
      this.fillHistory();

      if (paramsData || storageData) {
        this.book.checkIn = fn.getDate(this.book.checkIn);
        this.book.checkOut = fn.getDate(this.book.checkOut);
        if (+this.book.checkIn <= +defaultDate || +this.book.checkOut <= +defaultDate) {
          this.initialDefaultDate();
        }
      }
      this.updateInputPaxes();
    },
    fillHistory() {
      this.form.from = this.book.place_name;
      this.form.to = this.book.place_name_to;
    },
      selectDestination(item, type, suffix = "") {
      const displayName = item.place_selected.version == "v2" ? this.textOrigen(item.place_selected) : this.textValidation(item.place_selected);
      this.book[`place_name${suffix}`] = displayName;
      this.book[`place_selected${suffix}`] = item.place_selected;
      this.form[type] = displayName;

      this.CloseSearch[type] = true;
      this.OpenSearch[type] = true;
      setTimeout(() => {
        this.OpenSearch[type] = false;
      }, 10);
      return item.place_selected.placeCode;
    },
    submitSearch() {
      if (!this.validateForm()) {
        return;
      }

      let paramsQuery = fn.search();
      let paxesData = SearchHistory.mapPackagePaxQuery(this.book.paxes);
      let data = {
        startingFromDateTime: fn.formatDate(this.book.checkIn, setting.formatDate),
        returningFromDateTime: fn.formatDate(
          this.book.checkOut,
          setting.formatDate,
        ),
        checkIn: fn.formatDate(this.book.checkIn, setting.formatDate),
        checkOut: fn.formatDate(this.book.checkOut, setting.formatDate),
        startingFromAirport: this.book.place_selected.placeCode,
        returningFromAirport: this.book.place_selected_to.placeCode,
        startingPlaceId: this.book.place_selected.placeId,
        returningPlaceId: this.book.place_selected_to.placeId,
      };

      if (paramsQuery.CampaignToken) {
        data.CampaignToken = paramsQuery.CampaignToken;
      }

      data = { ...data, ...paxesData };

      var path = `${config.pathPackages}`;
      _tracker.metricBookerPackage("booker", { vmData: this.book, data });

      var formEl = document.createElement("form");
      formEl.setAttribute("method", "get");
      formEl.setAttribute("action", `${path}`);

      for (var key in data) {
        if (data[key]) {
          var hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", key);
          hiddenField.setAttribute("value", data[key]);
          formEl.appendChild(hiddenField);
        }
      }

      SearchHistory.set(this.book, "P");
      $("#loader-page").removeClass("d-none");
      document.body.appendChild(formEl);
      formEl.submit();
    },
    setFieldError(key, value) {
      this.fieldErrors[key] = value;
    },
    clearFieldErrors() {
      this.fieldErrors.from = "";
      this.fieldErrors.to = "";
      this.fieldErrors.dates = "";
      this.fieldErrors.guests = "";
    },
    textOrigen(suggestion) {
        const text = `${suggestion.placeDescription}, ${this.stripHtml(suggestion.placeName)} (${suggestion.placeCode})`;
        return text;
    },
    textValidation(suggestion) {
        const placeName = this.stripHtml(suggestion.placeName);
        const placeDescription = this.stripHtml(suggestion.placeDescription);
        const text = placeName == placeDescription ? placeName : `${placeDescription}, ${placeName}`;
        return text;
    }
  },
});
